export default {
    en: {
        title: 'Settings',
        chooseTheme: 'Choose Theme',
        defaultTheme: 'Default Theme',
        dark: 'Dark Theme',
        payments: 'Price Of products',
    },
    uz: {
        title: 'Sozlamalar',
        chooseTheme: "Ranglar to'plamini tanlang",
        defaultTheme: "Och ranglar",
        dark: "To'q ranglar",
        payments: "Mahsulot narxlari",
    },
    ru: {
        title: 'Настройки',
        chooseTheme: 'Выберите тему',
        defaultTheme: 'Тема по умолчанию',
        dark: 'Dark Theme',
        payments: 'Цена продуктов',
    }
}